import './styles.scss'
import React from 'react'
import { COFFEE_PEDIA } from 'Utils/Constants'

const CoffeePedia = () => (
  <div className="coffeepedia-container">
    <video controls className="coffeepedia-video" autoPlay loop playsInline>
      <source src={COFFEE_PEDIA.video} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
)

export default CoffeePedia
